<template>
  <base-card class="assignment-card">
    <div class="row align-items-center justify-content-around ml-2 p-3 assignment-container">
      <div class="col-xs-3 pr-3 ml-1">
        <font-awesome-icon class="hourglass-icon" :icon="['fal', 'hourglass-half']"></font-awesome-icon>
      </div>
      <div class="col-xs-9 mr-auto progress-container">
        <h5 class="m-0 p-0" v-if="currentCourse">{{
            grabI18NTranslation(currentCourse.attributes.name)
          }}</h5>
        <div class="progress">
          <div class="progress-bar" role="progressbar"
              :style="{ width: userActivitiesCompletedPercentageV2(currentMember) }" aria-valuemin="0"
              aria-valuemax="100"></div>
        </div>
        <p class="m-0 p-0" v-if="this.currentActivityMembers">{{ getCompletionStatusText(currentMember) }}</p>
      </div>
      <div class="col-xs-3 mr-2">
        <font-awesome-icon class="chevron" :icon="['fal', 'chevron-right']"></font-awesome-icon>
      </div>
    </div>
  </base-card>
</template>

<script>
import {mapState} from 'vuex';
import LocaleHandling from '@/mixins/locale-handling';
import BaseCard from '@/components/base-card/base-card.vue';
import CommonMemberFunctions from '@/mixins/common-member-functions';

export default {
  name: 'AssignmentCard',
  mixins: [LocaleHandling, CommonMemberFunctions],
  components: {
    BaseCard,
  },
  computed: {
    ...mapState(['currentUser', 'currentActivityMembers', 'currentCourse', 'currentMember']),
    totalSubmissions() {
      if (this.currentActivityMembers) {
        return this.currentActivityMembers.data.filter((member) => member.attributes.success === true && member.attributes.completion === true);
      }
      return [];
    },
    progressWidth() {
      if (this.currentActivityMembers) {
        const totalActivities = this.currentActivityMembers.data.length;
        return ((this.totalSubmissions.length / totalActivities) * 100).toFixed(2);
      }
      return 0;
    },
  },
};
</script>

<style scoped lang="scss" src="./styles.scss">

</style>
